export default __webpack_public_path__ + "static/marketplace-2bc7f946eda8baaded0d82856fae163a.png";